// 定义内容
export default {
	label: {
		one1: 'User name login',
		two2: 'Mobile number',
	},
	link: {
		one3: 'Third party login',
		two4: 'Links',
	},
	account: {
		accountPlaceholder1: 'The user name admin or not is common',
		accountPlaceholder2: 'Password: 123456',
		accountPlaceholder3: 'Please enter the verification code',
		accountBtnText: 'Sign in',
	},
	mobile: {
		// placeholder1: 'Please input mobile phone number',
		placeholder1: 'mobile phone number',
		// placeholder2: 'Please enter the verification code',
		placeholder2: 'code',
		codeText: 'Get code',
		invitationCodeText: 'Invitation code',
		btnText: 'Sign in',
		msgText:
			'Warm tip: it is recommended to use Google, Microsoft edge, version 79.0.1072.62 and above browsers, and 360 browser, please use speed mode',
	},
	scan: {
		text: 'Open the mobile phone to scan and quickly log in / register',
	},
	signInText: 'welcome back!',
	router: {
		home: 'home',
		chat: 'Intelligent Q&A',
		file: 'Knowledge Base',
		uie: 'UIE',
		system: 'system',
		personage: 'personage',
		systemMenu: 'commonLayout',
		systemRole: 'Data Entry',
		systemUser: 'Data Display',
		systemDept: 'systemDept',
		systemDic: 'systemDic',
		personal: 'personal',
		layoutLinkView: 'LinkView',
		layoutIframeViewOne: 'IframeViewOne',
		layoutIframeViewTwo: 'IframeViewTwo',
	},
	staticRoutes: {
		signIn: 'signIn',
		notFound: 'notFound',
		noPower: 'noPower',
	},
	user: {
		title1: 'Language switching',
		title3: 'Layout configuration',
		title4: 'news',
		title5: 'Full screen on',
		title6: 'Full screen off',
		dropdown1: 'home page',
		dropdown2: 'Personal Center',
		dropdown3: '404',
		dropdown4: '401',
		dropdown5: 'Log out',
		searchPlaceholder: 'Menu search: support Chinese, routing path',
		newTitle: 'notice',
		newBtn: 'All read',
		newGo: 'Go to the notification center',
		newDesc: 'No notice',
		logOutTitle: 'Tips',
		logOutMessage: 'This operation will log out. Do you want to continue?',
		logOutConfirm: 'determine',
		logOutCancel: 'cancel',
		logOutExit: 'Exiting',
		small: 'small',
		default: '中',
		large: '大',
	},
	tagsView: {
		refresh: 'refresh',
		close: 'close',
		closeOther: 'closeOther',
		closeAll: 'closeAll',
		fullscreen: 'fullscreen',
		closeFullscreen: 'closeFullscreen',
	},
	notFound: {
		foundTitle: 'Wrong address input, please re-enter the address~',
		foundMsg: 'You can check the web address first, and then re-enter or give us feedback.',
		foundBtn: 'Back to home page',
	},
	noAccess: {
		accessTitle: 'You are not authorized to operate~',
		accessBtn: 'Reauthorization',
	},
	layout: {
		themeColor: 'theme color',
		configTitle: 'Layout configuration',
		oneTitle: 'Global Themes',
		twoTopTitle: 'top bar set up',
		twoMenuTitle: 'Menu set up',
		twoTopBar: 'Top bar background',
		twoTopBarColor: 'Top bar default font color',
		twoMenuBar: 'Menu background',
		twoMenuBarColor: 'Menu default font color',
		twoMenuBarActiveColor: 'Menu Highlight Color',
		threeTitle: 'Interface settings',
		threeIsCollapse: 'Menu horizontal collapse',
		threeIsUniqueOpened: 'Menu accordion',
		threeIsFixedHeader: 'Fixed header',
		threeIsClassicSplitMenu: 'Classic layout split menu',
		fourTitle: 'Interface display',
		fourIsShowLogo: 'Sidebar logo',
		fourIsBreadcrumb: 'Open breadcrumb',
		fourIsBreadcrumbIcon: 'Open breadcrumb icon',
		fourIsTagsview: 'Open tagsview',
		fourIsTagsviewIcon: 'Open tagsview Icon',
		fourIsCacheTagsView: 'Enable tagsview cache',
		fourIsSortableTagsView: 'Enable tagsview drag',
		fourIsShareTagsView: 'Enable tagsview sharing',
		fourIsFooter: 'Open footer',
		fourIsGrayscale: 'Grey model',
		fourIsDark: 'Dark Mode',
		fourIsWartermark: 'Turn on watermark',
		fourWartermarkText: 'Watermark copy',
		fiveTitle: 'Other settings',
		fiveTagsStyle: 'Tagsview style',
		fiveAnimation: 'page animation',
		sixTitle: 'Layout switch',
		sixDefaults: 'One',
		sixClassic: 'Two',
		sixTransverse: 'Three',
		tipText: 'Click the button below to copy the layout configuration to `/src/stores/themeConfig.ts` It has been modified in.',
		copyText: 'replication configuration',
		resetText: 'restore default',
		copyTextSuccess: 'Copy succeeded!',
		copyTextError: 'Copy failed!',
	},
	uie: {
		introTitleUIE: 'YAYI-UIE accurate',
		introTitleExtrac: ' knowledge extraction ',
		introTitleAI: 'AI assistant',
		introTitleMain: 'Based on millions of Chinese and English data, combined with supervised fine-tuning and human intention alignment, it performs well in the field of information extraction, supporting complex scene information extraction in public opinion, media publicity, finance, security and other fields.',
		enterkeyword: 'Enter keywords',
		enterDetail: 'enter',
		extractInfor: 'Extract information',
		extractContent: 'Extract content',
		extractResults: 'Extraction result',
		copyJSON: 'Copy JSON',
		extractionProgress: 'Extracting',
		sendExtractedView: 'Check on the left after sending the extraction content',
		record: 'Chats',
		historyRecord: 'Historical record',
		confirmDeletSession: 'Confirm to delete this session',
		confirm: 'Confirm',
		cancel: 'Cancel',
		submit: 'Submit',
		nohistory: 'No historical records',
		feedbackMeansLot: 'Your feedback is of great significance to us, and we hope you can fill in your opinion',
		moreDesAnswer: 'What surprises have I brought you?',
		abnormalNetwork: 'The current network is abnormal, check the network',
		copySuccessful: 'The replication is successful',
		likeSuccess: 'Like success',
		tapSuccess: 'The tap is successful',
		hisNameNoEmpty: 'The history name cannot be empty'
	}
};
